import { TranslatedContent } from "../shared/Language";
import _dictionary from "../assets/translations"
import { DefaultId } from "../shared/Globals";
import { getLanguage } from "./LocalStorageHooks"

const currentLanguage = getLanguage()

export const lang = (term: (string | number | undefined)): string => {
    if (!term) return ""
    const local = term.toString()
    const item = _dictionary[local];
    if (!item) return local
    if (!item[currentLanguage] && item[DefaultId]) return item[DefaultId]
    if (!item[currentLanguage]) return local
    return _dictionary[local][currentLanguage]
}

export const translateContent = (content: TranslatedContent): string => {
    if (!content) return ""
    if (content[currentLanguage]) return content[currentLanguage]
    else if (content[DefaultId]) return content[DefaultId]
    else return ""
}

export const createEnDaContent = ( en: string, da: string): TranslatedContent => {
    return {
        [DefaultId]: en,
        da
    }
}